import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { useInstance } from 'intact-vue';
export function useAccept() {
  var instance = useInstance();
  var extensions = [];
  var mimeTypes = [];
  var groupTypes = [];
  instance.on('$receive:accept', parseAccept);
  function parseAccept(accept) {
    extensions = [];
    mimeTypes = [];
    groupTypes = [];
    if (accept) {
      accept.split(',').forEach(function (item) {
        item = _trimInstanceProperty(item).call(item).toLowerCase();
        if (item[0] === '.') {
          extensions.push(item.substring(1));
        } else {
          var _item$split = item.split('/'),
            type = _item$split[0],
            extension = _item$split[1];
          if (extension === '*') {
            groupTypes.push(type);
          } else {
            mimeTypes.push(item);
          }
        }
      });
    }
  }
  function isValidType(type, name) {
    if (_includesInstanceProperty(mimeTypes).call(mimeTypes, type)) return true;
    var index = name.lastIndexOf('.');
    type = type.split('/')[0];
    if (index > -1) {
      var extension = name.substring(index + 1).toLowerCase();
      if (_includesInstanceProperty(extensions).call(extensions, extension)) return true;
    }
    return _includesInstanceProperty(groupTypes).call(groupTypes, type);
  }
  return {
    isValidType: isValidType
  };
}